<div class="form-group row">
    <ng-content select=".label"></ng-content>
    <!-- <div class="{{cssClass}}">  Bryan Change offset in page add company-->
    <div class="col-sm-7">
        <ng-content select=".select"></ng-content>
    </div>
</div>